import { useEffect } from "react";
import "@/App.css";
import Landing from "@/pages/Landing";
import useLenis from "@/hooks/useLenis";

function App() {
  useLenis();

  useEffect(() => {
    document.documentElement.lang = "it";
  }, []);

  return (
    <div className="App grain" data-testid="app-root">
      <Landing />
    </div>
  );
}

export default App;
